import { render } from "./BlogConversationPage.vue?vue&type=template&id=be8609c8&scoped=true"
import script from "./BlogConversationPage.vue?vue&type=script&lang=js"
export * from "./BlogConversationPage.vue?vue&type=script&lang=js"

import "./BlogConversationPage.vue?vue&type=style&index=0&id=be8609c8&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8609c8"]])

export default __exports__